export const getDownloadLink = (
	referrer: 'panel' | 'config' = 'panel',
): string => {
	const urlParams = new URLSearchParams(window.location.search);
	const isMobile = urlParams.get('platform') === 'mobile';

	if (isMobile) {
		return 'https://www.voicemod.net/en/download-mobile/?utm_source=TWITCHEXT&utm_medium=PLUGIN&utm_campaign=VOICEMODCLIPS';
	}

	if (referrer === 'config') {
		return 'https://www.voicemod.net/en/live-twitch-extension/?utm_source=TWITCHEXT&utm_medium=PLUGIN-INSTALL&utm_campaign=VOICEMODCLIPS';
	}

	return 'https://www.voicemod.net/?utm_source=TWITCHEXT&utm_medium=PLUGIN&utm_campaign=VOICEMODCLIPS';
};
